module.exports = __webpack_public_path__ + "img/4.fba29c79.jpg";